const colors = {
  black: "#000000",
  dimGray: "#6f6f6f",
  navy: "#003a66",
  sapphire: "#005f9e",
  featherGray: "#f1f1f4",
  lightGray: "#e5e5e5",
  roseQuartz: "#fbf2f4",
  shades: {
    50: "#f7f7f7",
    100: "#f1f1f1",
    200: "#e2e2e2",
    300: "#c9c9c9",
    400: "#adadad",
    500: "#929292",
    600: "#7f7f7f",
    700: "#5b5b5b",
    800: "#383838",
    900: "#272727",
    1000: "#1a1a1a",
  },
  white: "#ffffff",
  error: "#d91943",
};

export type Colors = typeof colors;
export default colors;
